var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.type === 'how' ? 'how-box' : 'info-box'},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"marker",attrs:{"aria-hidden":""}},[_c('b-icon',{attrs:{"icon":"lightbulb-on"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }